module.exports = __webpack_public_path__ + "img/tertiary_9x3.798eb80a.svg";